"use client";

import { useRef, useState } from "react";

const BP = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export default function ShowVideoPlayer({ videoPath, startTime = 0 }: { videoPath: string; startTime?: number }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setMuted(videoRef.current.muted);
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current && startTime > 0) {
      videoRef.current.currentTime = startTime;
    }
  };

  return (
    <div style={{ position: "relative", marginBottom: 40, background: "black" }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        onLoadedMetadata={handleLoadedMetadata}
        style={{ width: "100%", aspectRatio: "16/9", display: "block", background: "black" }}
      >
        <source src={`${BP}/api/video/${videoPath}`} />
      </video>
      <button
        onClick={toggleMute}
        aria-label={muted ? "Unmute video" : "Mute video"}
        style={{
          position: "absolute",
          bottom: 16,
          right: 16,
          background: "rgba(0,0,0,0.55)",
          border: "1px solid rgba(255,255,255,0.25)",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "var(--font-mono)",
          fontSize: 9,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          padding: "7px 14px",
          cursor: "pointer",
        }}
      >
        {muted ? "Unmute" : "Mute"}
      </button>
    </div>
  );
}
